import { LoadableBackground } from '@confluence/loadable';

export const PremiumOnboarding = LoadableBackground({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-PremiumOnboarding" */ '../src/PremiumOnboarding.tsx'))
			.PremiumOnboarding,
});
